import React from "react";
import { Link } from "react-router";
import SiteHead from "./shared/components/header";

import "./app.css";
import Footer from "./shared/components/footer";

class NavDropdown extends React.Component {
  constructor(props) {
    super(props);
    // Check if any submenu item matches current path on mount
    const isActive = props.items.some(item => props.currentPath === item.path);
    this.state = { isOpen: isActive };
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    // Auto-open dropdown if navigated to one of its submenu pages
    if (prevProps.currentPath !== this.props.currentPath) {
      const isActive = this.props.items.some(item => this.props.currentPath === item.path);
      if (isActive && !this.state.isOpen) {
        this.setState({ isOpen: true });
      } else if (!isActive && this.state.isOpen) {
        // Close dropdown if navigated away from submenu pages
        this.setState({ isOpen: false });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  toggleDropdown = (e) => {
    e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  closeDropdown = () => {
    // Don't close dropdown when clicking submenu items - let componentDidUpdate handle it
    // This keeps the dropdown open when navigating between submenu pages
  };

  render() {
    const { label, items, currentPath } = this.props;
    const { isOpen } = this.state;
    
    // Check if any submenu item is active (matches current path)
    const isActive = items.some(item => currentPath === item.path);

    return (
      <div className="nav-dropdown" ref={this.dropdownRef}>
        <button 
          className={`top-nav-item ${isActive ? 'active' : ''}`}
          onClick={this.toggleDropdown}
        >
          {label}
          <svg 
            width="12" 
            height="12" 
            viewBox="0 0 12 12" 
            fill="currentColor"
            style={{ marginLeft: '6px', transition: 'transform 0.2s', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
          >
            <path d="M6 8L2 4h8z"/>
          </svg>
        </button>
        {isOpen && (
          <div className="nav-dropdown-menu">
            {items.map((item, index) => {
              // Check if this specific item is active
              const isItemActive = currentPath === item.path;
              return (
                <Link 
                  key={index}
                  to={item.path} 
                  className={`nav-dropdown-item ${isItemActive ? 'active' : ''}`}
                  onClick={this.closeDropdown}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { navMini: false };
    this.logout = this.logout.bind(this);
  }

  logout() {
    // Logout functionality handled by parent component
  }
  
  render() {
    const currentPath = this.props.location.pathname;

    return (
      <div className="app-wrapper">
        <SiteHead />
        <nav className="top-nav">
          {/* <Link to="/dashboard" className="top-nav-item" activeClassName="active">
            Dashboard
          </Link> */}
          <Link to="/facilitysetup" className="top-nav-item" activeClassName="active">
            Facility Setup
          </Link>
          <NavDropdown 
            label="Questions"
            currentPath={currentPath}
            items={[
              { path: '/state_questions', label: 'State Wise Added Questions' },
              { path: '/facility_questions', label: 'Facility Wise Added Questions' }
            ]}
          />
          <NavDropdown 
            label="Observation"
            currentPath={currentPath}
            items={[
              { path: '/observation_questions', label: 'State Wise Observation Questions' }
            ]}
          />
          <Link to="/reports" className="top-nav-item" activeClassName="active">
            Reports
          </Link>
          <NavDropdown 
            label="Audit Registers"
            currentPath={currentPath}
            items={[
              { path: '/tracking-report', label: 'Audit Reports Tracking' },
              { path: '/audit-register', label: 'Audit Register' }
            ]}
          />
        </nav>
        <div className="content-container">
          {this.props.children}
        </div>
        <Footer />
      </div>
    );
  }
}
